import React, { FC } from 'react';

import {
	DELETED_TEST_POPUP_TEXT,
	DELETED_TEST_POPUP_TITLE,
	DELETED_TEST_STATE_KEY
} from 'src/apps/web-sdks/helpers/WebSdkConsts';
import { ReportNotFoundPopup } from 'src/common/components/report-not-found-popup/ReportNotFoundPopup';

export const WebSdkTestDeletedPopup: FC = () => {
	return (
		<ReportNotFoundPopup
			title={DELETED_TEST_POPUP_TITLE}
			text={DELETED_TEST_POPUP_TEXT}
			stateKey={DELETED_TEST_STATE_KEY}
			isCentered
		/>
	);
};
